import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FormGenerator from "../../core/form-generator";
import {
  ADDRESS_FORM,
  descForm,
  getTicketFormRow3,
  getTicketFormRow1,
  isFormValid,
  formatFreeServicesPayload,
  complaintCodeForm,
  convertedData,
  SERVICE_OBJECT,
  getUnitMachineStatusForm,
} from "./helper";
import { HTTP_METHODS, invokeApi, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { getOfflineData } from "../../utils/offline-services";
import { useNavigate, useParams } from "react-router-dom";
import PastHistory from "./past-history";
import "./index.scss";
import FreeServices from "./free-services";
import SiFileUpload from "../../core/file-uploader";
import { handleFormValidation, splitFileName } from "../../utils";
import { toast } from "react-toastify";
import PreviewFormGenerator from "../../core/preview-form-generator";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SiTextField from "../../core/si-textfield";
import CustomButtonComponent from "../../core/custom-button";
import FormContainer from "../../core/form-container";
import { Icon } from "@iconify/react";
import CustomModal from "../../core/modal";
import ConfirmationPopup from "./confirmation-popup";
import AppContext from "../../utils/context";
import moment from "moment";
import SiAutocomplete from "../../core/si-autocomplete";

const TicketForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { userDetails = {} } = useContext(AppContext);
  const [formData, setFormData] = useState({
    attachments: "no",
    actionTakenByOem: "",
    oemServiceEngineerName: !userDetails?.admin ? userDetails?.name : "",
    oemServiceEngineerContact: userDetails?.phoneNumber || "",
    engineSerialNumber: "",
  });
  const [errors, setErrors] = useState({});
  const [oemNames, setOemNames] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedSearchEngine, setSelectedSearchEngine] = useState("");
  const [searchEngineOptions, setSearchEngineOptions] = useState([]);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [isUnderWarranty, setIsUnderWarranty] = useState({
    showText: false,
    value: null,
  });
  const [pastHistory, setPastHistory] = useState([]);
  const [isPreviewForm, setIsPreviewForm] = useState(false);
  const [oemList, setOemList] = useState([]);
  const [isShowConfirmation, setShowConfirmation] = useState({
    isOpen: false,
    ticketId: "",
  });
  const engineTimeoutRef = React.useRef(null);
  const showManualEntryCheckbox =
    hasSearched && searchEngineOptions.length === 0;
  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.LIST_OEMS}`, null)
      .then((response) => {
        if (Array.isArray(response) && response) {
          let user = getOfflineData("user") || {};
          let oems = response.map((r) => {
            return {
              ...r,
              label: r.name,
              value: r.id,
            };
          });
          setFormData({
            ...formData,
            oemName:
              (oems || []).find((oem) => oem.id === user.oemNameId) || {},
          });
          setOemNames(oems);
          if (id) {
            loadData(oems);
          }
        }
      })
      .catch((err) => console.error(err));
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: r.id,
            };
          });
          setComplaintCodes(codes);
        }
      })
      .catch((err) => console.error(err));
  };
  const submitHandler = () => {
    let payload = { ...formData };
    payload.freeServiceDetails = formatFreeServicesPayload(serviceList);
    payload.pastHistory = pastHistory;
    payload.oemEngineLocation = {
      tractorAddress: payload.tractorAddress,
      city: payload.city,
      pinCode: payload.pinCode,
      state: payload.state?.value,
    };
    payload.oemName = formData.oemName?.label;
    payload.oemServiceEngineerName =
      payload?.oemServiceEngineerName?.value || payload?.oemServiceEngineerName;
    payload.unitMachineStatus =
      formData.unitMachineStatus?.value || formData.unitMachineStatus || null;
    payload.natureOfCustomerComplaint =
      formData.natureOfCustomerComplaint?.value;
    payload.customerRegularApplication =
      formData?.customerRegularApplication?.value;
    payload.applicationWhileComplaintObserved =
      formData?.applicationWhileComplaintObserved?.value;
    payload.soilCondition = formData?.soilCondition?.value;
    if (files.length > 0) {
      payload.attachmentUrls = files.map((f) => splitFileName(f.url || ""));
    }
    delete payload.city;
    delete payload.pinCode;
    delete payload.state;
    delete payload.tractorAddress;

    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.COMPLAINT}`, payload)
      .then((response) => {
        if (response.message) {
          toast.error(`Failed to create ticket, ${response.message}`);
          setIsPreviewForm(false);
        } else {
          toast.success(`Ticket Created Successfully`);
          // navigate("/oem/service-support");
          setShowConfirmation({ isOpen: true, ticketId: response.id });
        }
      })
      .catch((err) => console.error(err));
  };

  const saveServices = (newService) => {
    setServiceList([...serviceList, newService]);
    setErrors({
      ...errors,
      freeServicesErr: false,
    });
  };

  const callBack = (newFile) => {
    if (Array.isArray(newFile)) {
      setFiles((prev) => [...prev, ...newFile]);
    } else {
      setFiles((prev) => [...prev, newFile]);
    }
  };

  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const previewFormHandler = () => {
    const firstForm = getTicketFormRow1(oemNames);
    const unitMachineStatusForm = getUnitMachineStatusForm();
    const secondForm = getTicketFormRow3(complaintCodes, userDetails, oemNames, false, formData.unitMachineStatus);
    const complaintForm = complaintCodeForm(complaintCodes);
    const descriptionForm = descForm(userDetails, oemNames, formData.unitMachineStatus);
    const isValid = handleFormValidation(
      [
        ...firstForm,
        ...ADDRESS_FORM,
        ...unitMachineStatusForm,
        ...secondForm,
        ...descriptionForm,
        ...complaintForm,
      ],
      setErrors,
      formData
    );
    if (isValid) {
      if (!formData.engineSerialNumber?.trim()) {
        toast.error("Engine Serial Number is required");
        return;
      }
      if (
        formData?.dateOfSale > new Date() ||
        formData?.customerComplaintDate > new Date()
      ) {
        toast.error("Future Dates not allowed");
        return;
      }
      if (formData?.hmr < 1) {
        toast.error("HMR should be greater than 0");
        return;
      }
      if (serviceList?.length) {
        for (const service of serviceList) {
          const serviceRunningHours = parseInt(service.runningHours);
          if (serviceRunningHours > formData?.hmr) {
            toast.error(
              `${service.name.label} running hours (${serviceRunningHours}) should be less than or equal to HMR (${formData?.hmr})`
            );
            return;
          }
        }
      }
      if (formData.hmr > 100 && serviceList?.length < 1) {
        toast.error("Please Add the Service History");
      } else {
        setIsPreviewForm(true);
      }
    } else {
      toast.error("Please correct the form data");
    }
  };
  const getOemList = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.HO_OEM_LIST}`)
      .then((response) => {
        const results = response?.map((ele) => ({
          label: `${ele?.code} - ${ele.name}`,
          value: ele?.name,
        }));
        setOemList(results);
        setFormData((prevVal) => ({
          ...prevVal,
          oemServiceEngineerName: results?.find(
            (ele) => ele?.value === userDetails?.name
          ),
        }));
      })
      .catch((err) => console.error(err));
  };
  const checkForEngineSerialPreviousTicket = (serialNumber) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.TICKET_PAST_HISTORY}/${serialNumber}`
    )
      .then((res) => {
        if (res?.complaintRecord) {
          const { complaintRecord = {} } = res;
          if (complaintRecord) {
            setPastHistory(complaintRecord?.pastHistory);
            const data = convertedData(complaintRecord?.freeServiceDetails);
            setServiceList(data);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const loadEngines = async (inputValue) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.SEARCH_ENGINE_LIST}`,
        { searchTerm: inputValue, oem: formData?.oemName?.id }
      );
      setSearchEngineOptions(
        response.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };
  const handleEngineSearch = (newInputValue) => {
    clearTimeout(engineTimeoutRef.current);
    if (newInputValue) {
      engineTimeoutRef.current = setTimeout(() => loadEngines(newInputValue), 300);
    } else {
      setSearchEngineOptions([]);
    }
    setHasSearched(!!newInputValue);
  };

  const checkWarranty = async (payload) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CHECK_WARRANTY}`,
        payload
      );
      setIsUnderWarranty({ showText: true, value: response?.underWarranty });
      if (!response?.underWarranty) {
        toast.error("Engine is out of warranty");
      }
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (formData.engineSerialNumber) {
        checkForEngineSerialPreviousTicket(formData.engineSerialNumber);
      }
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [formData.engineSerialNumber]);
  useEffect(() => {
    if (userDetails?.admin) {
      getOemList();
    }
  }, [userDetails]);
  useEffect(() => {
    if (formData?.engineSerialNumber && formData?.dateOfSale && formData?.hmr) {
      const timeoutId = setTimeout(() => {
        checkWarranty({
          engineSerialNumber: formData?.engineSerialNumber,
          saleDate: formData?.dateOfSale,
          hmr: formData?.hmr,
        });
      }, 2000);
      return () => clearTimeout(timeoutId);
    } else {
      setIsUnderWarranty({ showText: false, value: null });
    }
  }, [formData?.engineSerialNumber, formData?.dateOfSale, formData?.hmr]);

  useEffect(() => {
    const statusValue =
      typeof formData.unitMachineStatus === "string"
        ? formData.unitMachineStatus
        : formData.unitMachineStatus?.value;
    const isStockStatus =
      statusValue === "Depot Stock" || statusValue === "Dealer Stock";

    if (isStockStatus) {
      setFormData((prevVal) => ({
        ...prevVal,
        // dateOfSale: null,
        customerRegularApplication: null,
        soilCondition: null,
      }));
    }
  }, [formData.unitMachineStatus]);

  return (
    <div>
      <FormContainer className="mt-0">
        <div className="page-load">
          {!isPreviewForm ? (
            <div>
              <p className="form-header" style={{ marginTop: "10px" }}>
                New Ticket
              </p>
              <FormGenerator
                config={getTicketFormRow1(oemNames, userDetails, oemList)}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <p className="form-sub-header">Customer Address</p>
              <FormGenerator
                config={ADDRESS_FORM}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <Grid item md={12} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Grid item md={3.8}>
                    <p style={{ marginTop: "0px" }}>Engine Serial Number *</p>
                    {!isManualEntry ? (
                      <SiAutocomplete
                        value={selectedSearchEngine}
                        onChange={(val) => {
                          setSelectedSearchEngine(val);
                          setFormData((prevVal) => ({
                            ...prevVal,
                            engineSerialNumber: val?.value || "",
                          }));
                        }}
                        options={searchEngineOptions}
                        placeholder="Engine Serial Number"
                        onInputChange={(newInputValue) =>
                          handleEngineSearch(newInputValue)
                        }
                      />
                    ) : (
                      <SiTextField
                        placeholder="Enter engine number manually"
                        value={formData.engineSerialNumber}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedSearchEngine({ label: val, value: val });
                          setFormData((prev) => ({
                            ...prev,
                            engineSerialNumber: val,
                          }));
                        }}
                      />
                    )}
                    {formData?.engineSerialNumber &&
                      isUnderWarranty?.showText && (
                        <Typography
                          color={isUnderWarranty?.value ? "green" : "error"}
                          sx={{ mt: 1 }}
                        >
                          {isUnderWarranty?.value
                            ? "Under Warranty"
                            : "Out of warranty"}
                        </Typography>
                      )}
                  </Grid>
                  {/* <Grid item md={3.5} sx={{ ml: 2 }}>
                    {showManualEntryCheckbox && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isManualEntry}
                            onChange={(e) => {
                              setSearchEngineOptions([]);
                              setIsManualEntry(e.target.checked);
                              if (!e.target.checked) {
                                setHasSearched(false);
                              }
                              setSelectedSearchEngine("");
                            }}
                            color="primary"
                          />
                        }
                        label="Engine number is wrong, please enter correct engine serial number"
                        style={{ marginTop: 8, color: "red" }}
                      />
                    )}
                  </Grid> */}
                  <Grid item md={4} sx={{ ml: 3 }}>
                    <FormGenerator
                      config={getUnitMachineStatusForm()}
                      formData={formData}
                      setFormData={setFormData}
                      errors={errors}
                      setErrors={setErrors}
                      fieldGridSize={12}
                    />
                  </Grid>
                </Box>

              </Grid>

              <FormGenerator
                key={`ticket-form-row3-${(typeof formData.unitMachineStatus === "string"
                  ? formData.unitMachineStatus
                  : formData.unitMachineStatus?.value) || "default"
                  }`}
                config={getTicketFormRow3(
                  complaintCodes,
                  userDetails,
                  oemNames,
                  false,
                  formData.unitMachineStatus
                )}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <div className="history-services">
                <FreeServices
                  onSave={saveServices}
                  serviceList={serviceList}
                  onDelete={(newHistory) => setServiceList(newHistory)}
                  formData={formData}
                  error={errors.freeServicesErr || false}
                />
                <PastHistory
                  onSave={(newHistory) =>
                    setPastHistory([...pastHistory, newHistory])
                  }
                  pastHistory={pastHistory}
                  onDelete={(newHistory) => setPastHistory(newHistory)}
                />
              </div>
              <FormGenerator
                config={complaintCodeForm(complaintCodes)}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <FormGenerator
                key={`desc-form-${(typeof formData.unitMachineStatus === "string"
                  ? formData.unitMachineStatus
                  : formData.unitMachineStatus?.value) || "default"
                  }`}
                config={descForm(userDetails, oemNames, formData.unitMachineStatus)}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <SiFileUpload id={null} callBack={callBack} multiple />
                <div>
                  <CustomButtonComponent
                    variant="contained"
                    onClick={previewFormHandler}
                    size="small"
                    sx={{ ml: 2, width: "150px" }}
                    endIcon={
                      <Icon
                        icon="majesticons:arrow-right"
                        width="1.2rem"
                        height="1.2rem"
                        style={{ color: "white" }}
                      />
                    }
                  >
                    Preview
                  </CustomButtonComponent>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Box sx={{ display: "flex" }}>
                <ArrowBackIcon
                  sx={{ mr: 1, cursor: "pointer" }}
                  onClick={() => setIsPreviewForm(false)}
                />
                <p className="form-header">Preview Ticket</p>
              </Box>
              <PreviewFormGenerator
                formConfig={getTicketFormRow1(oemNames)}
                formValues={formData}
              />
              <p className="form-sub-header">Customer Address</p>
              <PreviewFormGenerator
                formConfig={ADDRESS_FORM}
                formValues={formData}
              />
              <Grid item md={12} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Grid item md={3.8}>
                    <p style={{ marginTop: "0px" }}>Engine Serial Number </p>
                    <SiTextField
                      placeholder="Engine Serial Number"
                      value={formData.engineSerialNumber}
                      type="text"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} sx={{ ml: 3 }}>
                    <p style={{ marginTop: "0px" }}>Unit / Machine Current Status</p>
                    <SiTextField
                      value={
                        typeof formData.unitMachineStatus === "object"
                          ? formData.unitMachineStatus?.label || ""
                          : formData.unitMachineStatus || ""
                      }
                      placeholder="Unit / Machine Current Status"
                      type="text"
                      disabled
                    />
                  </Grid>
                </Box>
              </Grid>

              <PreviewFormGenerator
                key={`preview-ticket-form-row3-${(typeof formData.unitMachineStatus === "string"
                  ? formData.unitMachineStatus
                  : formData.unitMachineStatus?.value) || "default"
                  }`}
                formConfig={getTicketFormRow3(
                  complaintCodes,
                  userDetails,
                  oemNames,
                  false,
                  formData.unitMachineStatus
                )}
                formValues={formData}
              />

              {serviceList.length > 0 && (
                <div>
                  <p>Engine service history</p>
                  <Grid container>
                    {serviceList.map((ele) => {
                      return (
                        <Grid item md={4} sx={{ pr: 3 }}>
                          <div>
                            <SiTextField
                              value={`${ele?.name?.label} - ${ele?.runningHours}hrs - ${ele?.date}`}
                              placeholder="Engine service history"
                              type="text"
                              disabled
                            />
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              )}
              {pastHistory.length > 0 && (
                <div>
                  <p>Past engine repair history</p>
                  <Grid container>
                    {pastHistory.map((ele) => {
                      return (
                        <Grid item md={4} sx={{ pr: 3 }}>
                          <div>
                            <SiTextField
                              value={`${ele?.complaintReported
                                } Complaint Reported  - ${moment(
                                  ele?.dateOfFailure
                                ).format("DD-MM-YYYY")} - ${ele?.hours}hrs`}
                              placeholder="Engine service history"
                              type="text"
                              disabled
                            />
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              )}
              <PreviewFormGenerator
                key={`preview-desc-form-${(typeof formData.unitMachineStatus === "string"
                  ? formData.unitMachineStatus
                  : formData.unitMachineStatus?.value) || "default"
                  }`}
                formConfig={descForm(userDetails, oemNames, formData.unitMachineStatus)}
                formValues={formData}
              />
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <CustomButtonComponent
                  variant="contained"
                  sx={{ width: "150px" }}
                  onClick={submitHandler}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            </div>
          )}

          {files.map((r, index) => {
            return (
              <div key={r.blobName + index}>
                <span>{r.blobName}</span>
                <IconButton onClick={() => onDelete(index)} sx={{ p: 0 }}>
                  <CancelOutlinedIcon />
                </IconButton>
              </div>
            );
          })}
        </div>
      </FormContainer>
      {isShowConfirmation?.isOpen && (
        <CustomModal
          onClose={() => {
            setShowConfirmation({ isOpen: false, ticketId: "" });
            navigate("/oem/service-support");
          }}
          contentClassName="ticket-confirmation-modal"
        >
          <ConfirmationPopup
            ticketId={isShowConfirmation?.ticketId}
            onClose={() => {
              setShowConfirmation({ isOpen: false, ticketId: "" });
              navigate("/oem/service-support");
            }}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default TicketForm;
